import "./Comments.scss";
import icon from "../../assets/Images/Mohan-muruge.jpg";
import commentIcon from "../../assets/Icons/add_comment.svg";

function Comments({ video, comments }) {
  return (
    <>
      <p className="article__comments">
        {comments && comments.length} Comments
      </p>
      <form className="comment__form">
        <img
          className="comment__icon"
          id="icon1"
          src={icon}
          alt="user-icon"
        ></img>
        <div className="comment__container">
          <div className="comment__container--input">
            <label htmlFor="commentField">Join the converstation</label>
            <input
              className="comment__input"
              type="text"
              name="commentField"
              placeholder="Add a new comment"
            ></input>
          </div>
          <div className="comment__container--button">
            <img
              src={commentIcon}
              className="comment__button--upload"
              alt="plus mark in bubble"
            ></img>
            <button id="comment" className="comment__button" type="submit">
              COMMENT
            </button>
          </div>
        </div>
      </form>
      <div className="comment__posts-container">
        <ul className="comment__list">
          {/* get comments from array specific to the selected video */}
          {comments &&
            comments.map((comment, index) => (
              <li className="comment__card" key={index}>
                <div className="comment__icon"></div>
                <div className="comment__card--right">
                  <div className="comment__card--top">
                    <p className="comment__user">{comment.name}</p>
                    <p className="comment__date">
                      {new Date(comment.timestamp).toLocaleDateString()}
                    </p>
                  </div>
                  <p className="comment__text">{comment.comment}</p>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </>
  );
}

export default Comments;
